<script>
export default {
  name: 'InteractiveAgentAvatar',

  props: {
    src: {
      type: [String, Boolean],
      default: false,
    },
    loading: {
      type: [Boolean],
      default: false,
    },
  },

  methods: {
    onClick() {
      if (this.loading) {
        return;
      }

      this.$emit('generate');
    },

    isLoading() {
      return this.loading;
    },

    hasCustomerAvatar() {
      return this.src && true;
    },
  },
};
</script>

<template>
  <div class="relative mb-8" @click="onClick">
    <img
      v-if="!hasCustomerAvatar()"
      src="~dashboard/assets/images/rudy-avatar.png"
      alt="Rookoo logo"
      class="border-slate-100 border-r rounded-full"
      height="160px"
      width="160px"
    />
    <img
      v-else
      :src="src"
      alt="Avatar logo"
      class="border-slate-100 border-r rounded-full"
      height="160px"
      width="160px"
    />
    <div
      class="rounded-full bg-slate-200 transition absolute top-0 bottom-0 left-0 right-0 h-full w-full opacity-0 flex items-center justify-center hover:opacity-80 hover:cursor-pointer"
    >
      <p class="m-0">{{ $t('ASSISTANT_MGMT.AVATAR.GENERATE_LABEL') }}</p>
    </div>
    <div
      v-show="isLoading()"
      class="rounded-full bg-slate-200 transition absolute top-0 bottom-0 left-0 right-0 h-full w-full opacity-80 flex items-center justify-center"
    >
      <p class="m-0">{{ $t('ASSISTANT_MGMT.AVATAR.LOADING_LABEL') }}</p>
    </div>
  </div>
</template>
